import { Button, Modal } from "antd";

const QrCodeDialog = ({ qrCodeOpen, handleQrcodeCancel, base64QR }) => {
  return (
    <Modal
      className="qr-modal"
      title={<div className="qr-title">QR CODE</div>}
      open={qrCodeOpen}
      onCancel={handleQrcodeCancel}
      closable={true}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .qr-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .qr-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .qr-modal .ant-modal-body{padding:16px 14px 14px;background:#eef1f8}
        .qr-modal .ant-modal-close{color:#fff}
        .qr-modal .ant-modal-close:hover{color:#ffd666;background:transparent}

        .qr-title{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:1px}

        .qr-card{background:#fff;border:2px solid #52bd91;border-radius:18px;padding:14px;display:flex;flex-direction:column;align-items:center;gap:8px;box-shadow:0 4px 14px rgba(82,189,145,.25)}
        .qr-img{width:100%;max-width:220px;height:auto;border-radius:10px}
        .qr-cap{font-size:12px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.6px}

        .qr-btn{margin-top:12px;width:100%;height:46px!important;border-radius:12px!important;font-weight:800!important;font-size:15px!important;background:linear-gradient(135deg,#162566,#2a3c8f)!important;border:0!important;color:#fff!important}
      `}</style>

      <div className="qr-card">
        <img className="qr-img" src={base64QR} alt="logo" />
        <span className="qr-cap">Scan to pay</span>
      </div>

      <Button type="primary" className="qr-btn" onClick={handleQrcodeCancel}>
        OK
      </Button>
    </Modal>
  );
};

export default QrCodeDialog;